import { Box } from '@mantine/core'

import { BackgroundSection } from '@/layouts/DefaultLayout/components/BackgroundSection/BackgroundSection'
import { Content } from '@/layouts/DefaultLayout/components/Content/Content'

import { LoginRoutePathsEnum } from '@/modules/login/routes/loginRouteConfig.types'

import { Anchor } from '@/components/Anchor/Anchor'
import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

import type { HomeStepProps } from './HomeStep.types'

export function HomeStep({
  button,
  imgSrc,
  isFinal,
  text,
  title,
}: HomeStepProps) {
  return (
    <>
      <BackgroundSection image={imgSrc} />
      <Content>
        <Title variant="h2">{title}</Title>

        {text && <Text>{text}</Text>}

        {button}

        {isFinal && (
          <Box mt={24}>
            <Text>
              Already have account?{' '}
              <Anchor href={LoginRoutePathsEnum.LOGIN} variant="primary">
                Log in
              </Anchor>
            </Text>
          </Box>
        )}
      </Content>
    </>
  )
}
